var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"df-search-files-app",staticStyle:{"width":"auto","height":"auto","background-color":"transparent"},attrs:{"dark":_vm.dark}},[_c('search-widget',{attrs:{"df-url":_vm.dfUrl,"dataset-id":_vm.datasetId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }